import { frontendURL } from '../../helper/URLHelper';
import {
  LEGACY_AGENT_ONLY_PERMISSIONS,
  SEARCH_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

import SearchView from './components/SearchView.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/search'),
    name: 'search',
    meta: {
      hideSecondarySidebar: true,
      permissions: {
        anyOf: [
          'administrator',
          LEGACY_AGENT_ONLY_PERMISSIONS,
          SEARCH_PERMISSIONS,
        ],
      },
    },
    component: SearchView,
  },
];
